import React from "react";
import { SummaryRow } from "@/pages/booking/bookingUi";

export const BookingSummary = ({ form, services }) => {
  const picked = services.filter((s) => (form.services || []).includes(s.id));
  const totalFrom = picked.reduce((sum, s) => sum + (Number(s.price_from) || 0), 0);
  const totalMin = picked.reduce((sum, s) => sum + (Number(s.duration_min) || 0), 0);
  return (
    <aside className="lg:col-span-4 hud-panel-silver rounded-xl p-10 space-y-6 scanlines h-fit lg:sticky lg:top-24">
      <div>
        <div className="flex items-center gap-2">
          <span className="h-1.5 w-1.5 rounded-full bg-brand-red blink-dot" />
          <div className="font-mono text-[10px] uppercase tracking-widest text-brand-red">Summary · Live</div>
        </div>
        <h3 className="mt-2 font-display uppercase text-2xl text-white tracking-tight">Your booking</h3>
      </div>
      <SummaryRow label="Customer" value={form.customer_name || "—"} />
      <SummaryRow label="Phone" value={form.customer_phone || "—"} />
      <div data-testid="summary-services">
        <div className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">
          Service{picked.length > 1 ? `s (${picked.length})` : ""}
        </div>
        {picked.length ? (
          <div className="mt-1 space-y-1">
            {picked.map((s) => (
              <div key={s.id} className="flex items-center justify-between gap-3">
                <span className="text-sm text-white">{s.title}</span>
                <span className="font-mono text-xs text-zinc-400">${s.price_from}</span>
              </div>
            ))}
          </div>
        ) : (
          <div className="mt-1 text-sm text-zinc-500">—</div>
        )}
      </div>
      <SummaryRow label="Vehicle" value={`${form.vehicle_make || "—"} ${form.vehicle_model || ""} ${form.vehicle_year ? `(${form.vehicle_year})` : ""}`} />
      <SummaryRow label="Rego" value={form.vehicle_rego ? `${form.vehicle_rego} · ${form.vehicle_state}` : "—"} />
      <SummaryRow label="Date" value={form.preferred_date} />
      <SummaryRow label="Time" value={form.preferred_time} />
      <div className="border-t border-zinc-900 pt-5">
        <div className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">
          Estimated{totalMin ? ` · ~${totalMin} min` : ""}
        </div>
        <div className="font-display text-4xl text-brand-red">
          ${picked.length ? totalFrom : "—"}
          <span className="text-zinc-500 text-sm font-mono ml-2">from</span>
        </div>
        <p className="mt-3 text-xs text-zinc-500 leading-relaxed">
          Final price confirmed in writing once we inspect your car. No work is started without your sign-off.
        </p>
      </div>
    </aside>
  );
};
